export const menuList = [
  {
    index: '1',
    title: 'dashboard',
    icon: 'ri-dashboard-2-line',
    hasNewFeature: false,
    path: '/dashboard'
  },

  {
    index: '3',
    title: 'News',
    icon: 'ri-file-list-3-line',
    permissionCode: 'news-view',
    hasNewFeature: 'news',
    path: '/news-section'
  },
  {
    index: '4',
    title: 'Projects',
    icon: 'ri-slideshow-line',
    permissionCode: 'project-list',
    hasNewFeature: false,
    path: '/projects'
  },
  {
    index: '27',
    title: 'TimeTracking',
    icon: 'ri-time-line',
    permissionCode: 'time-tracking-list',

    path: '/time-tracking'
  },
  {
    index: '411',
    title: 'Timeline',
    icon: 'ri-bar-chart-horizontal-line',
    hasNewFeature: false,
    path: '/timeline'
  },
  {
    index: '5',
    title: 'leave',
    icon: 'ri-calendar-check-line',
    permissionCode: 'leave-request-list',
    hasNewFeature: 'leave_management',
    path: '/leaves/list'
  },
  {
    index: '6',
    title: 'Payment',
    icon: 'ri-wallet-3-line',
    permissionCode: 'payment-list',
    hasNewFeature: 'payment',
    path: '/invoices/list'
  },
    {
    index: '30',
    title: 'AssetRequest',
    icon: 'ri-file-list-3-line',
    permissionCode: 'asset-request-list',

    path: '/asset-requests/list'
  },
  {
    index: '7',
    title: 'Booking',
    icon: 'ri-reserved-line',

    hasNewFeature: false,
    children: [
      {
        groupTitle: 'Booking',
        items: [
          {
            index: '8',
            title: 'Rooms',

            permissionCode: 'room-list',
            path: '/room-reservation'
          },
          {
            index: '9',
            title: 'Cars',

            permissionCode: 'car-list',

            path: '/car-reservation'
          }
        ]
      }
    ]
  },

  {
    index: '10',
    title: 'Employees',
    icon: 'ri-shield-user-line',
    permissionCode: 'employee-list',
    hasNewFeature: false,
    path: '/employees'
  },
  {
    index: '11',
    title: 'Clients',
    icon: 'las la-building',
    permissionCode: 'client-list',
    hasNewFeature: false,
    path: '/clients'
  },
  {
    index: '2',
    title: 'subscription',
    icon: 'ri-bank-card-line',
    permissionCode: 'subscription-list-request',
    hasNewFeature: false,
    path: '/subscriptions'
  },
  {
    index: '12',
    title: 'OrganizationSetup',
    icon: 'ri-building-line',
    permissionCode: true,
    hasNewFeature: false,
    children: [
      {
        groupTitle: 'OrganizationSetup',
        items: [
          {
            index: '13',
            title: 'Departments',

            permissionCode: 'department-list',
            path: '/departments'
          },
          {
            index: '14',
            title: 'groups',
            permissionCode: 'group-list',
            path: '/groups'
          },
          {
            index: '15',
            title: 'Positions',
            permissionCode: 'position-list',
            path: '/positions'
          }
        ]
      }
    ]
  },
  {
    index: '16',
    title: 'ApprovalForms',
    icon: 'ri-file-list-3-line',
    permissionCode: 'vas-request-list',
    hasNewFeature: 'vas_approval_form',
    path: '/forms/list'
  },
  {
    index: '17',
    title: 'ReservationsSettings',
    icon: 'ri-settings-2-line',
    permissionCode: true,

    children: [
      {
        groupTitle: 'Booking',
        items: [
          {
            index: '18',
            title: 'Rooms',
            permissionCode: 'room-list',
            path: '/room'
          },
          {
            index: '19',
            title: 'Cars',
            permissionCode: 'car-list',
            path: '/cars'
          },
          {
            index: '20',
            title: 'Buildings',
            permissionCode: 'building-list',
            path: '/room/building'
          },
          {
            index: '21',
            title: 'floor',
            permissionCode: 'building-view',
            path: '/room/floor'
          },
          {
            index: '22',
            title: 'drivers',
            permissionCode: 'driver-list',
            path: '/driver-reservation'
          },
          {
            index: '22-asset',
            title: 'asset',
            permissionCode: 'asset-list',
            path: '/Assets'
          }
        ]
      }
    ]
  },
  {
    index: '23',
    title: 'analytics',
    icon: 'ri-line-chart-line',
    permissionCode: true,
    hasNewFeature: 'analytics',

    children: [
      {
        groupTitle: 'analytics',
        items: [
          {
            index: '24',
            title: 'user',
            permissionCode: 'analytics-user-list',
            path: '/analytics/user'
          },
          {
            index: '25',
            title: 'task',
            permissionCode: 'analytics-task-list',
            path: '/analytics/task'
          },
          {
            index: '26',
            title: 'project',
            permissionCode: 'analytics-project-list',
            path: '/analytics/project'
          },
          {
            index: '27',
            title: 'department',
            permissionCode: 'analytics-department-list',
            path: '/analytics/department'
          }
        ]
      }
    ]
  },

  {
    index: '28',
    title: 'OrganizationChart',
    icon: 'ri-organization-chart',
    permissionCode: 'organization-chart-view',

    path: '/organization-chart'
  },
  {
    index: '29',
    title: 'RolesPermissions',
    icon: 'ri-git-repository-private-line',
    permissionCode: 'role-list',

    path: '/role-permission'
  }
];
